

export const askUserToSetUpAccount = async ( data = {}) => {
    
    

      const startAccountSetup = (await import(/* webpackPrefetch: true */ "./startAccountSetup")).startAccountSetup;

      const output = `
            <div 
                style="
                    min-width:100vw; 
                    width:100vw; 
                    min-height:100vh;
                    height:100vh; 
                    position:fixed; 
                    z-index:850; 
                    top:0;
                    left:0;
                    display:flex; 
                    flex-direction: column; 
                    align-items:center;
                    justify-content:center;
                "
                class="smetio-neutral-background accountSetupDiv"
            >

                <h1 class="smetio-dominant-text"> Welcome to 3ack </h1>
                <p> for business owners </p>

                <h4 style="margin-bottom:25px; margin-top:50px;" class="smetio-accent-text"> Let's help you setup your account </h4>

                <h6> Click on the button below to begin </h6>

                <button style=" margin-top:50px; border-radius:5px; border:solid 0.5px transparent; outline:solid 0.5px transparent; padding:7.5px;" class="setUpAccoutBtn smetio-dominant-background smetio-accent-text"> 
                    Get started 
                </button>
            </div>
          
        `;
  
      $("body").append(output);
  
      $("body").on("mousedown", ".setUpAccoutBtn", () => {
                
            const instruct = "<h4>Kindly follow the insturctions on the smartbox </h4>";
            $(".accountSetupDiv").html(instruct);

            return startAccountSetup();
  
      });
    
};
